 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLE_PAGE from '@/components/title_page'
 import DEDICATION from '@/components/Dedication'
 import EPIGRAPH from '@/components/Epigraph'
 import NAV from '@/components/nav'
 import CHAPTER_1 from '@/components/Chapter_1'
 import CHAPTER_2 from '@/components/Chapter_2'
 import CHAPTER_3 from '@/components/Chapter_3'
 import CHAPTER_4 from '@/components/Chapter_4'
 import CHAPTER_5 from '@/components/Chapter_5'
 import CHAPTER_6 from '@/components/Chapter_6'
 import CHAPTER_7 from '@/components/Chapter_7'
 import CHAPTER_8 from '@/components/Chapter_8'
 import CHAPTER_9 from '@/components/Chapter_9'
 import CHAPTER_10 from '@/components/Chapter_10'
 import CHAPTER_11 from '@/components/Chapter_11'
 import CHAPTER_12 from '@/components/Chapter_12'
 import CHAPTER_13 from '@/components/Chapter_13'
 import CHAPTER_14 from '@/components/Chapter_14'
 import CHAPTER_15 from '@/components/Chapter_15'
 import CHAPTER_16 from '@/components/Chapter_16'
 import CHAPTER_17 from '@/components/Chapter_17'
 import CHAPTER_18 from '@/components/Chapter_18'
 import CHAPTER_19 from '@/components/Chapter_19'
 import CHAPTER_20 from '@/components/Chapter_20'
 import CHAPTER_21 from '@/components/Chapter_21'
 import CHAPTER_22 from '@/components/Chapter_22'
 import CHAPTER_23 from '@/components/Chapter_23'
 import CHAPTER_24 from '@/components/Chapter_24'
 import CHAPTER_25 from '@/components/Chapter_25'
 import CHAPTER_26 from '@/components/Chapter_26'
 import CHAPTER_27 from '@/components/Chapter_27'
 import CHAPTER_28 from '@/components/Chapter_28'
 import CHAPTER_29 from '@/components/Chapter_29'
 import CHAPTER_30 from '@/components/Chapter_30'
 import CHAPTER_31 from '@/components/Chapter_31'
 import CHAPTER_32 from '@/components/Chapter_32'
 import CHAPTER_33 from '@/components/Chapter_33'
 import CHAPTER_34 from '@/components/Chapter_34'
 import CHAPTER_35 from '@/components/Chapter_35'
 import AUTHOR_NOTE from '@/components/Author_Note'
 import DISCUSSION_QUESTIONS from '@/components/Discussion_Questions'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import ANNOUNCEMENT from '@/components/Announcement'
 import TEASER_EXCERPT from '@/components/Teaser_Excerpt'
 import ABOUT_THE_AUTHOR from '@/components/About_the_Author'
 import BACK_AD_GWEN_MARCEY_SER from '@/components/Back_Ad_Gwen_Marcey_ser'
 import ENDORSEMENTS from '@/components/Endorsements'
 import CARD_PAGE from '@/components/Card_Page'
 import ECOPYRIGHT from '@/components/E-Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/Dedication",
 			"name" : "Dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/Epigraph",
 			"name" : "Epigraph",
 			"component" : EPIGRAPH
 		},
 		{
 			"path" : "/nav",
 			"name" : "nav",
 			"component" : NAV
 		},
 		{
 			"path" : "/Chapter_1",
 			"name" : "Chapter_1",
 			"component" : CHAPTER_1
 		},
 		{
 			"path" : "/Chapter_2",
 			"name" : "Chapter_2",
 			"component" : CHAPTER_2
 		},
 		{
 			"path" : "/Chapter_3",
 			"name" : "Chapter_3",
 			"component" : CHAPTER_3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js